import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'

import Buefy from 'buefy'
//import 'buefy/dist/buefy.css'
import '@mdi/font/css/materialdesignicons.css'
import '@/assets/Styles.scss'
//$primary: #18A0FB;
Vue.use(Buefy)

Vue.config.productionTip = false

import firebase from 'firebase/app'
// import 'firebase/auth'
import 'firebase/firestore'
import 'firebase/storage'
var firebaseConfig = {
  apiKey: "AIzaSyAKDhevlQSZJ9VSy1e40x7zwF9xugpsMt0",
  authDomain: "aceso-webflow-project.firebaseapp.com",
  databaseURL: "https://aceso-webflow-project.firebaseio.com",
  projectId: "aceso-webflow-project",
  storageBucket: "aceso-webflow-project.appspot.com",
  messagingSenderId: "345489776882",
  appId: "1:345489776882:web:077e39320abce2bc93306b",
  measurementId: "G-8F7Y5X8HLD"
};
firebase.initializeApp(firebaseConfig);
const db = firebase.firestore()
const storage = firebase.storage()

const references = {
  // practice: 'DEV_practices',
  // user: 'DEV_users'
  practice: 'PROD_practices',
  user: 'PROD_users'
}

export { db, storage, references } 

let unsubscribe; // needed in both mounted and beforeDestroy, we can subscribe and unsubscribe to store mutations
new Vue({
  router,
  store,
  mounted() {
    firebase.auth().onAuthStateChanged(async(user) => {
      if (user) {
        // practice.users was having issues with persisted state, so now we only persist auth.user. Which means we need to dispatch fetch Practice on every refresh
        if (!this.practice) {
          this.fetchPractice({ user })
        }
        unsubscribe = this.$store.subscribe(({ type, payload }) => { // listen for when practice is loaded
          if (type==='auth/IS_READY') {
            if (payload) {
              // is this even necessary? nothing is being called $on('ready')
              this.$root.$emit('ready') // tell components/owner/addEmployees, and App.vue that everything is loaded
              unsubscribe() // stop listening, for performance reasons
            }
          }
        })
        return
      } else {
        // unbind everything and reset
        this.$store.dispatch('stripe/unbindAllFirestore');
        this.$store.commit('stripe/RESET');
        this.$store.dispatch('auth/unbindAllFirestore');
        this.$store.commit('auth/RESET');
        this.$store.commit('RESET');
        return
      }
    })
  },
  beforeDestroy() {
    unsubscribe()
  },
  data () {
    return {
      msView: null,
      // *********** // used for adding new patients
      firstName: null,
      lastName: null,
      email: null,
      // *********** //
    }
  },
  methods: {
    async fetchPractice({ user }) {
      // fetch the user
      const userDoc = await db.collection(references.user).doc(user.uid).get();
      user = userDoc.data();
      const practice = user.practice.id;
      this.$store.dispatch('auth/fetchPractice', { user }); // call this last, so that the non reactive arrays in bindPatientsList and bindCustomTemplates have time to load
      this.$store.dispatch('bindPatientsList', practice);
      this.$store.dispatch('bindCustomTemplates', practice);
    },
    getURL(path) { // the entire bucket is public, but we have to apply a random tag to the end to beat the browser's image caching
      /* throwing in a random tag prevents the browser's image caching from showing the same image, 
         since the link's addressing is not changing  */
      // const url = path.url || path;
      const url = path;
      const randTag = Math.random().toString(36).substring(7);
      // console.log(`${url}?${randTag}=`)
      return `${url}?${randTag}=`;
      // return `https://storage.googleapis.com/aceso-webflow-project.appspot.com/${path}?${randTag}=`;
    },
    getDate(seconds, fullDate) {
      const milliseconds = seconds * 1000;
      let options = { weekday: 'long', hour: 'numeric', minute: 'numeric' };
      if (fullDate) {
        options = { weekday: 'long', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric' };
      }
      return new Date(milliseconds).toLocaleDateString(undefined, options);
    },
    convertTime(duration) { // accessed in multiple components
      // returns time in a pretty way
      let hrs = ~~(duration / 3600); // ~~ is short for ```Math.floor```
      let mins = ~~((duration % 3600) / 60);
      let secs = ~~duration % 60;
      let ret = "";
      if (hrs > 0) {
        ret += "" + hrs + ":" + (mins < 10 ? "0" : "");
      }
      ret += "" + mins + ":" + (secs < 10 ? "0" : "");
      ret += "" + secs;
      return ret;
    },
  },
  render: function (h) { return h(App) }
}).$mount('#app')